import { css } from 'emotion'

export const ServerErrorStyles = css``
